import axios from "axios";
import Cookies from "js-cookie";
import { keepAuthPassPhrase, TicketingApiUri, apiKey } from "./constants";
import CryptoJS from "crypto-js";
import { DateTime } from "luxon";

var currTitle = null;
var currSubTitle = null;

export const getEndevreID = () => {
  var deviceID = "nodevid";
  var userNormalToken = "nousertoken";
  var txMA = undefined;
  var xauth = undefined;

  if (Cookies.get("devID") !== undefined) {
    var deviceID_bytes = null;
    try {
      deviceID_bytes = CryptoJS.AES.decrypt(
        Cookies.get("devID"),
        "79fw49wd7jw8df3h",
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.NoPadding,
        }
      );
    } catch (e) {
      // delete cookie
      Cookies.remove("devID");
      return null;
    }
    var device_ID = undefined;
    try {
      device_ID = deviceID_bytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      // delete cookie
      Cookies.remove("devID");
    }
    // setDeviceID(device_ID.replace(/[^a-zA-Z0-9]/g, ""));
    deviceID = device_ID.replace(/[^a-zA-Z0-9]/g, "");
  }

  if (Cookies.get("endevre_id_token") !== undefined) {
    // var userNormalToken_bytes = CryptoJS.AES.decrypt(
    //   Cookies.get("usernormaltoken"),
    //   "79fw49wd7jw8df3h",
    //   { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.NoPadding }
    // );
    // // setUserNormalToken(userNormalToken_bytes.toString(CryptoJS.enc.Utf8));
    // userNormalToken = userNormalToken_bytes
    //   .toString(CryptoJS.enc.Utf8)
    //   .replace(/\\f+$/, "")
    //   .trim();
    // // userNormalToken = userNormalToken_bytes.toString(CryptoJS.enc.Utf8);

    userNormalToken = Cookies.get("endevre_id_token");
  }

  if (Cookies.get("txMA_xauth__") !== undefined) {
    // var txMA_bytes = CryptoJS.AES.decrypt(Cookies.get("txMA_xauth__"), CryptoJS.enc.Utf8.parse("79fw49wd7jw8df3h"), {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.NoPadding});
    // setTxMA(txMA_bytes.toString(CryptoJS.enc.Utf8));
    // setTxMA(Cookies.get("txMA_xauth__"));
    txMA = Cookies.get("txMA_xauth__");
  }

  if (Cookies.get("xauth") !== undefined) {
    // var xauth_bytes = CryptoJS.AES.decrypt(Cookies.get("xauth"), CryptoJS.enc.Utf8.parse("79fw49wd7jw8df3h"), {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.NoPadding});
    // setXAuth(xauth_bytes.toString(CryptoJS.enc.Utf8));
    // setXAuth(Cookies.get("xauth"));
    xauth = Cookies.get("xauth");
  }

  return { deviceID, userNormalToken, txMA, xauth };
};

const { deviceID, userNormalToken } = getEndevreID();

/**
 * gets the cached global user state (if user is logged in)
 * returns null if no cached state found
 * @returns {object} {firstName, lastName}
 */
export const getCachedGlobalUserState = (args = { debug: false }) => {
  const globalUserCacheCookieName = "gxU__CA";
  const cacheEncryptionKey = "8eWkfE93Pl2v8d2fv8jr3xai90mt4d7h";

  if (args.debug) console.log("GETTING CACHED GLOBAL USER STATE");

  // null if no cookie found
  if (!Cookies.get(globalUserCacheCookieName)) {
    if (args.debug) console.warn("NO CACHED GLOBAL USER STATE FOUND");
    return null;
  }

  // decrypt cookie
  // let decrypted = CryptoJS.AES.decrypt(
  //   Cookies.get(globalUserCacheCookieName),
  //   cacheEncryptionKey,
  //   { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.NoPadding }
  // ).toString(CryptoJS.enc.Utf8);
  let decrypted = CryptoJS.AES.decrypt(
    Cookies.get(globalUserCacheCookieName),
    cacheEncryptionKey
  );

  try {
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    // delete cookie
    if (args.debug)
      console.error("Error fetching cached global user state: ", e);
    Cookies.remove(globalUserCacheCookieName);
    return null;
  }

  // parse decrypted cookie
  let parsed = decodeJSON(decrypted);

  // error handle on parsing
  if (parsed === null) {
    // delete cookie
    if (args.debug)
      console.error("Error fetching cached global user state: unable to parse");
    Cookies.remove(globalUserCacheCookieName);
    return null;
  }

  // return parsed cookie
  if (args.debug) console.log("CACHED GLOBAL USER STATE FOUND");
  if (args.debug) console.log(parsed);
  return parsed;
};

/**
 * caches the global user state (if user is logged in)
 * @param {Object} globalUser - the global user object to cache
 * @returns true if successful, null if not
 */
export const setCachedGlobalUserState = (globalUser) => {
  const globalUserCacheCookieName = "gxU__CA";
  const cacheEncryptionKey = "8eWkfE93Pl2v8d2fv8jr3xai90mt4d7h";

  // check if globalUser is valid
  if (!globalUser || !globalUser.firstName || !globalUser.lastName) {
    console.error(
      "Error caching global user state: invalid global user object, deleting any existing cache"
    );
    Cookies.remove(globalUserCacheCookieName);
    return null;
  }

  // create object
  let cachedGlobalUser = {
    firstName: globalUser.firstName,
    lastName: globalUser.lastName,
  };

  // stringify object
  let stringified = JSON.stringify(cachedGlobalUser);

  // encrypt object
  let encrypted = CryptoJS.AES.encrypt(stringified, cacheEncryptionKey);

  // set cookie
  Cookies.set(globalUserCacheCookieName, encrypted, { expires: 1 });

  console.log("CACHED GLOBAL USER STATE SET");

  // return true
  return true;
};

export const exchangeIDAuth = async (code, origin) => {
  let response = null;

  const URL = TicketingApiUri + 'auth/exchange.php';

  const formData = new FormData();
  formData.append("code", code);
  formData.append("origin", origin);

  try {
    response = await axios.post(URL, formData);
  } catch (error) {
    response = error.response;
  } finally {
    return response;
  }
};

export const verifyAuthUser = async (eventid) => {
  async function verifyCardCode(code) {
    let responseCard = null;

    try {
      responseCard = await axios.get(
        TicketingApiUri + "readcard.php?apikey=" + apiKey + "&cardcode=" + code
      );
    } catch (error) {
      responseCard = error.response;
    } finally {
      console.log(responseCard.data);

      // check if cardcode is valid
      if (responseCard.data.status !== "200") {
        // handle error
        return null;
      }

      // check if cardcode eventid matches eventid
      if (responseCard.data.data.eventID !== eventid) {
        return null;
      }

      // decrypt keepAuth cookie to check for validity
      let decrypted = CryptoJS.AES.decrypt(
        Cookies.get("keepAuth"),
        keepAuthPassPhrase
      ).toString(CryptoJS.enc.Utf8);
      let decryptedCardCode = decrypted.substring(0, 12);
      let dateDiff = Math.abs(Date.now() - Number(decrypted.substring(12)));

      // check to make sure dateDiff is less than 15 minutes or if decrypted code is not equal to code
      if (decryptedCardCode !== code || dateDiff > 900000) {
        return null;
      }

      return responseCard.data.data;
    }
  }

  if (
    Cookies.get("cardcode") === undefined ||
    Cookies.get("keepAuth") === undefined
  ) {
    return null;
  }

  let cardInf = await verifyCardCode(Cookies.get("cardcode"));

  return { cardcode: Cookies.get("cardcode"), cardinfo: cardInf };
};

export const setTitle = (title = null, subtitle = null) => {
  // update titles if given new ones
  if (title) currTitle = title;
  if (subtitle) currSubTitle = subtitle;

  let newTitle = "Advent by Endevre";

  if (currTitle) newTitle = currTitle + " | " + newTitle;
  if (currSubTitle) newTitle = currSubTitle + " | " + newTitle;

  document.title = newTitle;
};

export const getEventDataHook = async (eventid, args = {}) => {
  let responseEvent;

  try {
    responseEvent = await axios.get(
      TicketingApiUri + "readevent.php?apikey=" + apiKey + "&eventID=" + eventid
    );
  } catch (error) {
    responseEvent = error.response;
  } finally {
    if (args.displayMode !== "none") {
      // console.log("Event Data [hook]:");
      // if (!args.displayMode) console.log(responseEvent.data);
      if (args.displayMode === "table")
        console.table(responseEvent?.data.events);
    }

    if (responseEvent?.data.status !== "200") {
      // handle error
      console.error(
        "Error getting event data: " + responseEvent?.data?.error_message
      );
      return null;
    }

    return responseEvent?.data;
  }
};

/**
 * Gets user card data
 * @param {string} code - cardcode or cardID value
 * @param {string} codeType - cardcode or cardID
 * @param {object} args - cvv (required if codeType is cardID), displayMode (logging display)
 */
export const getCardDataHook = async (
  code,
  codeType = "cardcode",
  args = {}
) => {
  console.log(args);
  // preform checks
  if (codeType !== "cardcode" && codeType !== "cardID") {
    console.error("Invalid codeType");
    return null;
  }
  if (codeType === "cardID" && !args.cvv && !userNormalToken) {
    console.error("cardID requires cvv");
    return null;
  }

  let responseCard = null;

  try {
    responseCard = await axios.get(
      TicketingApiUri +
        "readcard.php?apikey=" +
        apiKey +
        "&" +
        codeType +
        "=" +
        code +
        (args.cvv ? "&cvv=" + args.cvv : "") +
        (userNormalToken ? "&token=" + userNormalToken : "") +
        (deviceID ? "&deviceID=" + deviceID : "") +
        (args.vendorID ? "&vendorID=" + args.vendorID : "") +
        (args.eventID ? "&eventID=" + args.eventID : "")
    );
  } catch (error) {
    responseCard = error.response;
  } finally {
    console.log("Card Data [hook]:");
    if (!args.displayMode) console.log(responseCard.data);
    if (args.displayMode === "table") console.table(responseCard.data?.data);

    if (responseCard.data.status !== "200") {
      // handle error
      console.error(
        "Error getting card data: " + responseCard?.data?.error_message
      );
      return null;
    }

    return responseCard.data;
  }
};

export const getImgsHook = (inputImgs) => {
  let imgs = null;

  // check if inputImgs is empty or undefined
  if (inputImgs === "" || inputImgs === undefined || inputImgs === null) {
    // console.log("ERR: No images to parse.");
    return;
  }

  try {
    imgs = JSON.parse(inputImgs);
  } catch (error) {
    console.log(imgs);
    console.error("ERR: JSON is invalid.");
    return;
  }

  // check to make sure filename and src exists for each key in imgs
  let allClear = true;
  Object.keys(imgs).forEach((key) => {
    if (imgs[key] === null) {
      console.error("ERR: Missing image.");
      console.error(imgs);
      allClear = false;
      return null;
    }

    if (!imgs[key].fileID) {
      console.error("ERR: Missing image ID.");
      console.error(imgs);
      allClear = false;
      return null;
    }

    if (!imgs[key].filePath && !imgs[key].path) {
      console.error("ERR: Missing image path.");
      console.error(imgs);
      allClear = false;
      return null;
    }

    if (!imgs[key].fileName && !imgs[key].filename) {
      console.error("ERR: Missing image filename.");
      console.error(imgs);
      allClear = false;
      return null;
    }

    if (imgs[key].path && imgs[key].filename) {
      imgs[key].src =
        "https://advent-cdn.endevre.com" + imgs[key].path + imgs[key].filename;
    } else {
      console.log(
        "You are using a deprecated image format. Please check Postman for current model."
      );
      imgs[key].src =
        "https://advent-cdn.endevre.com" +
        imgs[key].filePath +
        imgs[key].fileName;
    }
  });
  if (!allClear) return null;

  return imgs;
};

/**
 *
 * @param {file} file - file to upload
 * @param {String} id - eventID or organizationID
 * @param {String} type - type of id (eventID or organizationID)
 * @param {*} args
 * @returns - the img obj
 */
export const createImg = async (file, id, type, args = {}) => {
  let imgResponse = null;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("apikey", apiKey);
  formData.append("token", userNormalToken);
  formData.append("deviceID", deviceID);
  formData.append(type, id);

  try {
    imgResponse = await axios({
      method: "post",
      url: TicketingApiUri + "createfile.php",
      maxBodyLength: Infinity,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    imgResponse = error.response;
  } finally {
    if (!args.displayMode) console.log("Create Image Response:");
    if (!args.displayMode) console.log(imgResponse?.data);
    if (args.displayMode === "table") console.table(imgResponse?.data);

    if (imgResponse.status !== 201) {
      console.error(imgResponse);
      return null;
    }

    let imgObj = {};

    imgObj = {
      fileID: imgResponse.data?.file?.fileID,
      filePath: imgResponse.data?.file?.path,
      fileName: imgResponse.data?.file?.filename,
    };

    return imgObj;
  }
};

export const deleteImg = async (id, fileID, idType, args = {}) => {
  let imgResponse = null;

  let formData = {
    apikey: apiKey,
    deviceID: deviceID,
    token: userNormalToken,
    fileID: fileID,
  };

  // add eventID or organizationID to formData
  if (idType) {
    formData[idType] = id;
  } else {
    // eventID by default
    formData["eventID"] = id;
  }

  try {
    imgResponse = await axios({
      method: "post",
      url: TicketingApiUri + "deletefile.php",
      maxBodyLength: Infinity,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    imgResponse = error.response;
  } finally {
    if (!args.displayMode) console.log("Delete Image Response:");
    if (!args.displayMode) console.log(imgResponse?.data);
    if (args.displayMode === "table") console.table(imgResponse?.data);

    if (imgResponse.status !== 200) {
      console.error(imgResponse);
      return null;
    }

    return imgResponse.data;
  }
};

/**
 *
 * @param {String} orgid - The organization ID
 */
export const getOrgData = async (orgid, args = {}) => {
  let responseOrg = null;

  try {
    responseOrg = await axios.get(
      TicketingApiUri +
        "readorganization.php?apikey=" +
        apiKey +
        "&organizationID=" +
        orgid
    );
  } catch (error) {
    responseOrg = error.response;
  } finally {
    if (args.displayMode !== "none") {
      console.log("Org Data:");
      console.log(responseOrg.data);
    }

    if (responseOrg.data.status !== "200") {
      // handle error
      console.error(
        "Error getting org data: " + responseOrg?.data?.error_message
      );
      return null;
    }

    return responseOrg.data;
  }
};

/**
 * Gets all events for an organization
 * @param {String} orgid - The organization ID
 * @returns {Object} - The response data or null if error
 */
export const getOrgEvents = async (orgid) => {
  let responseOrgEvents = null;

  try {
    responseOrgEvents = await axios.get(
      TicketingApiUri +
        "readevent.php?apikey=" +
        apiKey +
        "&organizationID=" +
        orgid
    );
  } catch (error) {
    responseOrgEvents = error.response;
  } finally {
    // console.log("Org Events:");
    // console.log(responseOrgEvents.data);

    if (responseOrgEvents.data.status !== "200") {
      // handle error
      console.error(
        "Error getting org events: " + responseOrgEvents?.data?.error_message
      );
      return null;
    }

    return responseOrgEvents.data;
  }
};

/**
 *
 * @param {String} id - The corresponding ID for call
 * @param {String} idtype - The type of ID (eventID, formID)
 * @param {Object} args - displayMode (logging display)
 * @returns ticket data on success, null on failure
 */
export const getTicketData = async (id, idtype, args = {}) => {
  let responseTicket = null;

  try {
    responseTicket = await axios.get(
      TicketingApiUri +
        "readform.php?apikey=" +
        apiKey +
        "&" +
        idtype +
        "=" +
        id
    );
  } catch (error) {
    responseTicket = error.response;
  } finally {
    if (args.displayMode !== "none") console.log("Ticket Data:");
    if (!args.displayMode) console.log(responseTicket?.data);
    if (args.displayMode === "table") console.table(responseTicket?.data);

    if (responseTicket.data.status !== "200") {
      // handle error
      console.error(
        "Error getting ticket data: " + responseTicket?.data?.error_message
      );
      return null;
    }

    return responseTicket.data;
  }
};

/**
 *
 * @param {String} id - the id of the submission
 * @param {String} idtype - the type of id (submissionID, formID, activation)
 * @param {*} args - displayMode (logging display)
 * @returns
 */
export const getSubmissionData = async (id, idtype, args = {}) => {
  let responseSubmission = null;

  try {
    responseSubmission = await axios.get(
      TicketingApiUri +
        "submissions/readsubmission.php?apikey=" +
        apiKey +
        "&" +
        idtype +
        "=" +
        id +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&sort=DESC"
    );
  } catch (error) {
    responseSubmission = error.response;
  } finally {
    if (args.displayMode !== "none") console.log("Submission Data:");
    if (!args.displayMode) console.log(responseSubmission?.data);
    if (args.displayMode === "table") console.table(responseSubmission?.data);

    if (responseSubmission.data.status !== "200") {
      // handle error
      console.error(
        "Error getting submission data: " +
          responseSubmission?.data?.error_message
      );
      return null;
    }

    return responseSubmission.data;
  }
};

/**
 *
 * @param {String} userid - the user id
 * @param {String} type - the type of id (userID, organizationID, eventID)
 * @param {*} args - (roles [comma separated list of roles], displayMode)
 * @returns
 */
export const getEventUserData = async (userid, type, args = {}) => {
  let responseEventUser = null;

  try {
    responseEventUser = await axios.get(
      TicketingApiUri +
        "readuser.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&" +
        type +
        "=" +
        userid +
        (args.roles ? "&roles=" + args.roles : "")
    );
  } catch (error) {
    responseEventUser = error.response;
  } finally {
    if (args.displayMode !== "none") console.log("Event User Data:");
    if (args.displayMode !== "none") console.log(responseEventUser?.data);
    if (args.displayMode === "table") console.table(responseEventUser?.data);

    if (responseEventUser.data.status !== "200") {
      // handle error
      console.error(
        "Error getting event user data: " +
          responseEventUser?.data?.error_message
      );
      return null;
    }

    return responseEventUser.data;
  }
};

/**
 *
 * @param {String} userid - the user id
 * @param {*} id - eventID or organizationID
 * @param {*} type - type of id (eventID, organizationID)
 * @param {*} args
 * @returns
 */
export const deleteEventUser = async (userid, id, type, args = {}) => {
  let responseEventUser = null;

  try {
    responseEventUser = await axios({
      method: "post",
      url: TicketingApiUri + "deleteuser.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        userID: userid,
        [type]: id,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseEventUser = error.response;
  } finally {
    console.log("Event User Data:");
    if (!args.displayMode) console.log(responseEventUser?.data);
    if (args.displayMode === "table") console.table(responseEventUser?.data);

    if (responseEventUser.data.status !== "200") {
      // handle error
      console.error(
        "Error deleting event user data: " +
          responseEventUser?.data?.error_message
      );
      return null;
    }

    return responseEventUser.data;
  }
};

export const createEventUser = async (
  endevreLogin,
  id,
  type,
  role,
  args = {}
) => {
  let responseEventUser = null;

  try {
    responseEventUser = await axios({
      method: "post",
      url: TicketingApiUri + "createuser.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        [type]: id,
        roles: role,
        endevreLogin: endevreLogin,
        firstName: "",
        lastName: "",
        data: JSON.stringify({ email: endevreLogin }),
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseEventUser = error.response;
  } finally {
    console.log("Event User Data:");
    if (!args.displayMode) console.log(responseEventUser?.data);
    if (args.displayMode === "table") console.table(responseEventUser?.data);

    if (responseEventUser.data.status !== "201") {
      // handle error
      console.error(
        "Error creating event user data: " +
          responseEventUser?.data?.error_message
      );
      return null;
    }

    return responseEventUser.data;
  }
};

export const createUser = async (mode, id, args = {}) => {
  let responseUser;

  const modes = {
    user: "userID",
    event: "eventID",
    organization: "organizationID",
  };

  if (!modes[mode]) {
    console.error("Invalid mode");
    return null;
  }

  try {
    responseUser = await axios({
      method: "post",
      url: TicketingApiUri + "createuser.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        [modes[mode]]: id,
        firstName: args.firstName || "",
        lastName: args.lastName || "",
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseUser = error.response;
  } finally {
    if (responseUser.data.status !== "201") {
      // handle error
      console.error(
        "Error creating user data: ",
        responseUser.data.error_message
      );
      return responseUser.data;
    }

    return responseUser.data;
  }
};

export const updateUser = async (mode, id, userid, args = {}) => {
  let responseUser;

  const modes = {
    user: "userID",
    event: "eventID",
    organization: "organizationID",
  };

  if (!modes[mode]) {
    console.error("Invalid mode");
    return null;
  }

  try {
    responseUser = await axios({
      method: "post",
      url: TicketingApiUri + "updateuser.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        [modes[mode]]: id,
        ...(mode !== "user" ? { userID: userid } : {}),
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseUser = error.response;
  } finally {
    console.log("User Data:");

    if (responseUser.data.status !== "200") {
      // handle error
      console.error(
        "Error updating user data:",
        responseUser.data.error_message
      );
      return responseUser.data;
    }

    return responseUser.data;
  }
};

export const later = (delay, value) => {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(value);
    }, delay);
  });
};

export const checkInUser = async (eventID, checkinArgs, status, args = {}) => {
  // let currDate = new Date();

  let responseCheckIn = null;

  try {
    responseCheckIn = await axios({
      method: "post",
      url: TicketingApiUri + "events/checkin.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        ...checkinArgs,
        // checkin: status ? Math.floor(currDate.getTime() / 1000) : "0",
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCheckIn = error.response;
  } finally {
    console.log("Check In Response:");
    if (!args.displayMode) console.log(responseCheckIn?.data);
    if (args.displayMode === "table") console.table(responseCheckIn?.data);

    if (responseCheckIn.data.status !== "200") {
      // handle error
      console.error(
        "Error checking in user: " + responseCheckIn?.data?.error_message
      );
    }

    return responseCheckIn.data;
  }
};

export const checkOutUser = async (eventID, checkinArgs, args = {}) => {
  // let currDate = new Date();

  let responseCheckIn = null;

  try {
    responseCheckIn = await axios({
      method: "post",
      url: TicketingApiUri + "events/checkout.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        ...checkinArgs,
        // checkin: status ? Math.floor(currDate.getTime() / 1000) : "0",
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCheckIn = error.response;
  } finally {
    console.log("Check In Response:");
    if (!args.displayMode) console.log(responseCheckIn?.data);
    if (args.displayMode === "table") console.table(responseCheckIn?.data);

    if (responseCheckIn.data.status !== "200") {
      // handle error
      console.error(
        "Error checking in user: " + responseCheckIn?.data?.error_message
      );
    }

    return responseCheckIn.data;
  }
};

export const readSubmissionWithInfo = async (code, codeType, args = {}) => {
  let responseSubmission = null;

  try {
    responseSubmission = await axios.get(
      TicketingApiUri +
        "submissions/readsubmissionwithinfo.php?apikey=" +
        apiKey +
        "&" +
        codeType +
        "=" +
        code +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken
    );
  } catch (error) {
    responseSubmission = error.response;
  } finally {
    console.log("Submission Data:", responseSubmission?.data);

    if (responseSubmission.data.status !== "200") {
      // handle error
      console.error(
        "Error getting submission data: " +
          responseSubmission?.data?.error_message
      );
    }

    return responseSubmission.data;
  }
};

export const replaceCard = async (userid, oldCardID, newCardID, args = {}) => {
  // check to make sure card is valid first
  let responseCheckCard = await getCardDataHook(newCardID, "cardID", {
    eventID: args.eventID,
  });

  if (!responseCheckCard) {
    console.error("Error programming card: card is not valid");
    return null;
  }

  // check the old card
  let responseCheckOldCard = await getCardDataHook(oldCardID, "cardID", {
    eventID: args.eventID,
  });

  if (!responseCheckOldCard) {
    console.error("Error programming card: old card is not valid");
    return null;
  }

  // get name of user if userid not none
  let userName = "";
  if (userid) {
    let responseUser = await getEventUserData(userid, "userID");
    if (!responseUser) {
      console.error("Error programming card: user is not valid");
      return null;
    }
    userName =
      responseUser.users[0].firstName + " " + responseUser.users[0].lastName;
  }

  let responseProgramCard = null;

  try {
    responseProgramCard = await axios({
      method: "post",
      url: TicketingApiUri + "replacecard.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        oldCardID: oldCardID,
        newCardID: newCardID,
        userID: userid,
        name: userName,
        status: args.status ? args.status : "1",
        ...(args.eventID ? { eventID: args.eventID } : {}), // add eventID if provided
        ...(args.resend ? { resend: args.resend } : {}), // resend if provided
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseProgramCard = error.response;
  } finally {
    console.log("Program Card Response:");
    if (!args.displayMode) console.log(responseProgramCard?.data);
    if (args.displayMode === "table") console.table(responseProgramCard?.data);

    if (responseProgramCard.data.status !== "200") {
      // handle error
      console.error(
        "Error programming card: " + responseProgramCard?.data?.error_message
      );
      return null;
    }

    return responseProgramCard.data;
  }
};

export const programCard = async (userid, cardid, args = {}) => {
  // check to make sure card is valid first
  let responseCheckCard = await getCardDataHook(cardid, "cardID", {
    eventID: args.eventID,
  });

  if (!responseCheckCard) {
    console.error("Error programming card: card is not valid");
    return null;
  }

  // get name of user if userid not none
  let userName = "";
  if (userid) {
    let responseUser = await getEventUserData(userid, "userID");
    if (!responseUser) {
      console.error("Error programming card: user is not valid");
      return null;
    }
    userName =
      responseUser.users[0].firstName + " " + responseUser.users[0].lastName;
  }

  let responseProgramCard = null;

  try {
    responseProgramCard = await axios({
      method: "post",
      url: TicketingApiUri + "updatecard.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        cardID: cardid,
        userID: userid,
        name: userName,
        status: args.status ? args.status : "1",
        ...(args.eventID ? { eventID: args.eventID } : {}), // add eventID if provided
        ...(args.resend ? { resend: args.resend } : {}), // resend if provided
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseProgramCard = error.response;
  } finally {
    console.log("Program Card Response:");
    if (!args.displayMode) console.log(responseProgramCard?.data);
    if (args.displayMode === "table") console.table(responseProgramCard?.data);

    if (responseProgramCard.data.status !== "200") {
      // handle error
      console.error(
        "Error programming card: " + responseProgramCard?.data?.error_message
      );
      return null;
    }

    return responseProgramCard.data;
  }
};

export const getTransactionData = async (id, idtype, args = {}) => {
  let responseTransaction = null;

  try {
    responseTransaction = await axios.get(
      TicketingApiUri +
        "readtransaction.php?apikey=" +
        apiKey +
        "&" +
        idtype +
        "=" +
        id +
        (deviceID ? "&deviceID=" + deviceID : "") +
        (userNormalToken ? "&token=" + userNormalToken : "") +
        "&sort=DESC"
    );
  } catch (error) {
    responseTransaction = error.response;
  } finally {
    console.log("Transaction Data:");
    if (!args.displayMode) console.log(responseTransaction?.data);
    if (args.displayMode === "table") console.table(responseTransaction?.data);

    if (responseTransaction.data.status !== "200") {
      // handle error
      console.error(
        "Error getting transaction data: " +
          responseTransaction?.data?.error_message
      );
      return null;
    }

    return responseTransaction.data;
  }
};

export const getEndevreUser = async (args = {}) => {
  // const {deviceID, userNormalToken} = getEndevreID();

  let responseUser = null;

  try {
    responseUser = await axios.get(
      TicketingApiUri +
        "readuser.php?endevreID=yes&apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken
    );
  } catch (error) {
    responseUser = error.response;
  } finally {
    console.log("Endevre User Data:");
    if (!args.displayMode) console.log(responseUser?.data);
    if (args.displayMode === "table") console.table(responseUser?.data);

    if (responseUser?.data?.status !== "200") {
      // handle error
      console.error(
        "Error getting event user data: " + responseUser?.data?.error_message
      );
      return null;
    }

    return responseUser?.data;
  }
};

/**
 *
 * @param {String} id - orgID, eventID, or global
 * @param {*} type - what type of id is it (orgID, eventID, or global)
 * @param {*} args
 * @returns
 */
export const getGlobalEndevreUser = async (id, type, args = {}) => {
  let endevreidUserResponse = await getEndevreUser();

  if (!endevreidUserResponse) {
    // user does not have an endevreid account, redirect ##FIX
    console.error("BAD RESPONSE");
    return null;
  }

  let globalUser = null;
  // get the global user
  endevreidUserResponse?.users?.forEach((user) => {
    if (user[type] === id) {
      globalUser = user;
    }
    if (type === "global" && user.eventID === "global") {
      globalUser = user;
    }
    return;
  });

  console.log("GLOBAL USER:");
  console.log(globalUser);

  return globalUser;
};

export const checkIsEventAdmin = async (eventID, orgID, args = {}) => {
  // first check if user is an org admin
  let orgUser = await getGlobalEndevreUser(orgID, "organizationID");

  if (!orgUser || orgUser?.roles !== "admin") {
    // if not, check if user is an event admin
    console.log("AUTH: user not admin of org, checking event");
    orgUser = await getGlobalEndevreUser(eventID, "eventID");
  }

  // console.log(orgUser)

  if (!orgUser || orgUser?.roles !== "admin") {
    // user is not admin of org or event, don't let them in
    console.error("AUTH: user not admin of event");
    // navigate("/error/1011");
    return null;
  }

  return orgUser;
};

/**
 *
 * @param {String} userID user id of user to mark paid
 * @param {*} paidStatus 0 or 1 (0 for unpaid, 1 for paid)
 * @param {*} args
 * @returns
 */
export const markUserPaid = async (userID, paidStatus, args = {}) => {
  let responseMarkPaid = null;

  try {
    responseMarkPaid = await axios({
      method: "post",
      url: TicketingApiUri + "updateuser.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        userID: userID,
        paid: paidStatus,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseMarkPaid = error.response;
  } finally {
    console.log("Mark Paid Response:");
    if (!args.displayMode) console.log(responseMarkPaid?.data);
    if (args.displayMode === "table") console.table(responseMarkPaid?.data);

    if (responseMarkPaid.data.status !== "200") {
      // handle error
      console.error(
        "Error marking user paid: " + responseMarkPaid?.data?.error_message
      );
      return null;
    }

    return responseMarkPaid.data;
  }
};

export const reloadCard = async (eventID, cardID, amount, type, args = {}) => {
  // get the eventVendor first
  let eventVendor = await getEventDataHook(eventID);

  if (!eventVendor) {
    console.error("Error getting event vendor");
    return null;
  }
  eventVendor = eventVendor.events?.eventVendor;

  let responseReloadCard = null;

  try {
    responseReloadCard = await axios({
      method: "post",
      url: TicketingApiUri + "createtransaction.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        cardID: cardID,
        vendorID: eventVendor,
        value: Number(amount),
        notes: "Administrative Balance Adjustment",
        type: type,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseReloadCard = error.response;
  } finally {
    console.log("Reload Card Response:");
    if (!args.displayMode) console.log(responseReloadCard?.data);
    if (args.displayMode === "table") console.table(responseReloadCard?.data);

    if (responseReloadCard.data.status !== "201") {
      // handle error
      console.error(
        "Error reloading card: " + responseReloadCard?.data?.error_message
      );
      return null;
    }

    return responseReloadCard.data;
  }
};

/**
 *
 * This function is TEMPORARY while we wait for pricing api.
 * @param {Object} submissionForm - the submission form object (MAKE SURE ALREADY JSON PARSED)
 * @param {*} args
 * @returns {Number, Number, Number} - totalPrice, totalBalance, totalPoints
 */
export const getTotalPrices = (submissionForm, args = {}) => {
  // check to make sure submissionForm is JSON object
  if (typeof submissionForm === "string") {
    submissionForm = JSON.parse(submissionForm);
  }

  let totalPrice = 0;
  let totalBalance = 0;
  let totalPoints = 0;

  // get total price of item packages
  Object.keys(submissionForm).forEach((key) => {
    let field = submissionForm[key];

    if (field.type === "Item Package") {
      field?.value?.forEach((item) => {
        if (item.checked) {
          totalPrice +=
            Number(item.price ? item.price : 0) *
            Number(item.quantity ? item.quantity : 1);
        }
      });
    }

    if (field.type === "Currency Package") {
      field?.value?.forEach((item) => {
        totalPrice += Number(item.price ? item.price : 0);
        totalBalance += Number(item.balance);
        totalPoints += Number(item.points);
      });
    }
  });

  return { totalPrice, totalBalance, totalPoints };
};

/**
 * safely decodes a JSON string
 * @param {String} jsonString - the JSON string to decode
 * @returns - the decoded JSON object or null if failed
 */
export const decodeJSON = (jsonString) => {
  let decodedString = null;

  // check if jsonString is empty
  if (!jsonString) {
    return decodedString;
  }

  try {
    decodedString = JSON.parse(jsonString);
  } catch (error) {
    console.error("Error decoding JSON string: " + error);
    decodedString = null;
  }

  return decodedString;
};

export const pruneUncheckedSubmissionValues = (submissionForm, args = {}) => {
  // null catch
  if (!submissionForm) {
    return submissionForm;
  }

  Object.keys(submissionForm).forEach((key) => {
    let field = submissionForm[key];

    if (field.type === "Item Package") {
      field.value = field?.value?.filter((item) => {
        return item.checked;
      });
    }
  });

  return submissionForm;
};

/**
 * this function will highlight the search query within the text (if present) and return
 * the text with the query highlighted
 * @param {String} text - the text to highlight
 * @param {String} query - the query to within the text to highlight
 * @returns
 */
export const highlightSearchQuery = (text, query) => {
  if (query) {
    let regex = new RegExp(query, "gi");
    let split = text.split(regex);
    let match = text.match(regex);
    let result = [];
    for (let i = 0; i < split.length; i++) {
      result.push(split[i]);
      if (match && match[i]) {
        result.push(<span className="bg-yellow-300/50">{match[i]}</span>);
      }
    }
    return result;
  } else {
    return text;
  }
};

export const getVendorOperators = async (id, type, args = {}) => {
  let responseOperators = null;

  try {
    responseOperators = await axios.get(
      TicketingApiUri +
        "readoperator.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&" +
        type +
        "=" +
        id
    );
  } catch (error) {
    responseOperators = error.response;
  } finally {
    console.log("Get Vendor Operators Response:");
    if (!args.displayMode) console.log(responseOperators?.data);
    if (args.displayMode === "table") console.table(responseOperators?.data);

    if (responseOperators.data.status !== "200") {
      // handle error
      console.error(
        "Error getting vendor operators: " +
          responseOperators?.data?.error_message
      );
      return null;
    }

    return responseOperators.data;
  }
};

export const getCurrEventUser = async (eventID) => {
  let userResponse = await getEndevreUser();

  if (!userResponse) {
    // handle error
    return null;
  }

  let eventUser = userResponse.users.find((user) => user.eventID === eventID);

  console.log("CURR EVENT USER:");
  console.log(eventUser);

  return eventUser;
};

/**
 * gets the current operator's status for the given event
 * @param {String} eventID - the event ID to get the operator status for
 * @returns the vendorID of the current operator or null if not vendor
 */
export const getOperatorStatus = async (eventID) => {
  let eventUser = await getCurrEventUser(eventID);

  if (!eventUser || eventUser?.roles !== "vendor") {
    // handle error
    console.warn("OPERATOR STATUS: user is not a vendor");
    return null;
  }

  // check to make sure user has active vendors
  let currActiveVendor = eventUser?.active_operators?.replace(",", "").trim();
  if (!currActiveVendor) {
    return null;
  }

  return currActiveVendor;
};

/**
 * gets a specific event's activity with the given threshold in seconds (24 hours by default)
 * @param {*} eventID - the event ID to get the activity for
 * @param {*} thres - the threshold in seconds to get the activity for
 */
export const getActivity = async (eventID, thres = 86400, period = 3600) => {
  let responseActivity = null;

  try {
    responseActivity = await axios.get(
      TicketingApiUri +
        "monitoring/readactivity.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&eventID=" +
        eventID +
        "&thresh=" +
        thres +
        "&chunkseconds=" +
        period
    );
  } catch (error) {
    responseActivity = error.response;
  } finally {
    if (responseActivity.data.status !== "200") {
      // handle error
      console.error(
        "Error getting activity: " + responseActivity?.data?.error_message
      );
      return null;
    }

    return responseActivity.data;
  }
};

/**
 * gets the current event's currency statistics (currency, tokens if enabled)
 * @param {*} eventID - the event ID to get the currency for
 */
export const getCurrency = async (eventID) => {
  let responseCurrency = null;

  try {
    responseCurrency = await axios.get(
      TicketingApiUri +
        "monitoring/readcurrency.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&eventID=" +
        eventID
    );
  } catch (error) {
    responseCurrency = error.response;
  } finally {
    console.log("Get Currency Response:");
    console.log(responseCurrency?.data);

    if (responseCurrency.data.status !== "200") {
      // handle error
      console.error(
        "Error getting currency: " + responseCurrency?.data?.error_message
      );
      return null;
    }

    return responseCurrency.data;
  }
};

/**
 * Generalized API get request for transactions, can be used for both events and vendors
 * @param {*} mode - either "event" or "vendor"
 * @param {*} id - the eventID or vendorID to get transactions for
 * @param {*} args - any additional arguments to pass to the API (EAPI docs)
 * @returns - the response from the API
 */
export const getTransaction = async (mode, id, args = []) => {
  let responseTransactions = null;

  const modes = {
    event: "eventID",
    vendor: "vendorID",
  };

  try {
    responseTransactions = await axios.get(
      TicketingApiUri +
        "readtransaction.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&" +
        modes[mode] +
        "=" +
        id +
        "&" +
        args.join("&")
    );
  } catch (error) {
    responseTransactions = error.response;
  } finally {
    if (responseTransactions.data.status !== "200") {
      // handle error
      console.error(
        "Error getting transactions: " +
          responseTransactions?.data?.error_message
      );
      return null;
    }

    return responseTransactions.data;
  }
};

export const getUser = async (mode, id, args = []) => {
  let userResponse = null;

  const modes = {
    userid: "userID",
    event: "eventID",
    organization: "organizationID",
  };

  try {
    userResponse = await axios.get(
      TicketingApiUri +
        "readuser.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&" +
        modes[mode] +
        "=" +
        id +
        "&" +
        args.join("&")
    );
  } catch (error) {
    userResponse = error.response;
  } finally {
    if (userResponse.data.status !== "200") {
      // handle error
      console.error("Error getting user: " + userResponse?.data?.error_message);
      return null;
    }

    return userResponse.data;
  }
};

export const getForm = async (mode, id, args = []) => {
  let formResponse = null;

  const modes = {
    event: "eventID",
    form: "formID",
  };

  try {
    formResponse = await axios.get(
      TicketingApiUri +
        "readform.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&" +
        modes[mode] +
        "=" +
        id +
        "&" +
        args.join("&")
    );
  } catch (error) {
    formResponse = error.response;
  } finally {
    if (formResponse.data.status !== "200") {
      // handle error
      console.error("Error getting form: " + formResponse?.data?.error_message);
      return null;
    }

    return formResponse.data;
  }
};

/**
 * This function will add the given event to the user's saved events
 * @param {String} eventID - the event ID of the event to be saved
 * @param {*} args
 * @returns {Object} - {response, error} - response is the response from the API, error is the error message if any
 */
export const addSavedEvent = async (eventID, args = {}) => {
  // let currUser = await getCurrEventUser(eventID);

  if (!deviceID || !userNormalToken) {
    // handle error
    console.error(
      "addSavedEvents: deviceID or userNormalToken is invalid or null"
    );
    return {
      response: null,
      error: "Error getting current user",
    };
  }

  let responseAddEvents = null;

  try {
    responseAddEvents = await axios({
      method: "post",
      url: TicketingApiUri + "users/addsavedevents.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseAddEvents = error.response;
  } finally {
    console.log("Add Saved Events Response:");
    if (!args.displayMode) console.log(responseAddEvents?.data);
    if (args.displayMode === "table") console.table(responseAddEvents?.data);

    if (responseAddEvents?.data?.status !== "200") {
      // handle error
      console.error(
        "Error adding saved event: " + responseAddEvents?.data?.error_message
      );
      return {
        response: null,
        error: "Error adding saved event",
      };
    }

    return {
      response: responseAddEvents.data,
      error: null,
    };
  }
};

/**
 * This function will remove the given event to the user's saved events
 * @param {String} eventID - the event ID of the event to be removed from saved events
 * @param {*} args
 * @returns {Object} - {response, error} - response is the response from the API, error is the error message if any
 */
export const removeSavedEvent = async (eventID, args = {}) => {
  // let currUser = await getCurrEventUser(eventID);

  if (!deviceID || !userNormalToken) {
    // handle error
    console.error(
      "removeSavedEvent: deviceID or userNormalToken is invalid or null"
    );
    return {
      response: null,
      error: "Error getting current user",
    };
  }

  let responseAddEvents = null;

  try {
    responseAddEvents = await axios({
      method: "post",
      url: TicketingApiUri + "users/removesavedevents.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseAddEvents = error.response;
  } finally {
    console.log("Remove Saved Events Response:");
    if (!args.displayMode) console.log(responseAddEvents?.data);
    if (args.displayMode === "table") console.table(responseAddEvents?.data);

    if (responseAddEvents?.data?.status !== "200") {
      // handle error
      console.error(
        "Error removing saved event: " + responseAddEvents?.data?.error_message
      );
      return {
        response: null,
        error: "Error adding saved event",
      };
    }

    return {
      response: responseAddEvents.data,
      error: null,
    };
  }
};

export const getAllUserPasses = async (args = {}) => {
  let responsePasses = null;

  try {
    responsePasses = await axios.get(
      TicketingApiUri +
        "users/getpasses.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken
    );
  } catch (error) {
    responsePasses = error.response;
  } finally {
    console.log("Get All User Passes Response:");
    if (!args.displayMode) console.log(responsePasses?.data);
    if (args.displayMode === "table") console.table(responsePasses?.data);

    if (responsePasses.data.status !== "200") {
      // handle error
      console.error(
        "Error getting user passes: " + responsePasses?.data?.error_message
      );
      return {
        response: null,
        error: responsePasses?.data?.error_message,
      };
    }

    return {
      response: responsePasses.data,
      error: null,
    };
  }
};

export const humanizeDate = (date, { locale = "" } = {}) => {
  let dateDate = new Date(date * 1000);

  let dateString = null;

  if (locale === "") {
    dateString = dateDate.toLocaleDateString([], {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } else {
    dateString = dateDate.toLocaleDateString(locale, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  return dateString;
};

export const humanizeTime = (time, { locale = "", twelveHour = true } = {}) => {
  let timeDate = new Date(time * 1000);
  let timeString = null;

  if (locale === "") {
    timeString = timeDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: twelveHour,
    });
  } else {
    timeString = timeDate.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: twelveHour,
    });
  }

  return timeString + " " + locale;
};

/**
 * getVendors - gets all the vendors for the given event
 * @param {*} eventID - the event ID of the event to get the vendors for
 * @returns - the vendors for the given event
 */
export const getVendors = async (eventID) => {
  let responseVendors;

  try {
    responseVendors = await axios.get(
      TicketingApiUri +
        "readvendor.php?apikey=" +
        apiKey +
        "&eventID=" +
        eventID
    );
  } catch (error) {
    responseVendors = error.response;
  } finally {
    if (responseVendors.data.status !== "200") {
      return null;
    }

    return responseVendors.data.vendors;
  }
};

/**
 * getVendor - gets the vendor data with the given vendorID
 * @param {*} vendorID - the vendor ID of the vendor to get
 * @returns - the vendor data
 */
export const getVendor = async (vendorID) => {
  let responseVendor;

  try {
    responseVendor = await axios.get(
      TicketingApiUri +
        "readvendor.php?apikey=" +
        apiKey +
        "&vendorID=" +
        vendorID
    );
  } catch (error) {
    responseVendor = error.response;
  } finally {
    if (responseVendor.data.status !== "200") {
      return null;
    }

    return responseVendor.data.vendors;
  }
};

/**
 * createVendor - creates a vendor with the given name, description, and data
 * @param {*} eventid - the event ID of the event to create the vendor for
 * @param {*} args - arguments for the vendor
 * @returns - the vendor ID of the created vendor
 */
export const createVendor = async (eventID, args) => {
  let responseVendor;

  try {
    responseVendor = await axios({
      method: "post",
      url: TicketingApiUri + "createvendor.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        eventID: eventID,
        name: args?.name,
        description: args?.description,
        category: args?.category,
        location: args?.location,
        orderAbility: args?.orderAbility,
        featured: args?.featured,
        maxOrders: args?.maxOrders,
        useOrder: args?.useOrder,
        cardSecurity: args?.cardSecurity,
        data: args?.data,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseVendor = error.response;
  } finally {
    if (responseVendor.status !== 201) {
      return null;
    }
    return responseVendor.data.vendorID;
  }
};

/**
 * deleteVendor - deletes the vendor with the given vendorID
 * @param {*} eventID - the event ID of the event to delete the vendor from
 * @param {*} vendorID - the vendor ID of the vendor to delete
 * @returns - the vendor data
 */
export const deleteVendor = async (eventID, vendorID) => {
  let responseVendor;

  try {
    responseVendor = await axios({
      method: "post",
      url: TicketingApiUri + "deletevendor.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        eventID: eventID,
        vendorID: vendorID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseVendor = error.response;
  } finally {
    if (responseVendor.data.status !== "200") {
      return null;
    }
  }

  return responseVendor.data;
};

/**
 * updateVendor - updates the vendor with the given vendorID
 * @param {*} eventID - the event ID of the event to update the vendor from
 * @param {*} vendorID - the vendor ID of the vendor to update
 * @param {*} args - arguments for the vendor
 * @returns - the vendor data
 */
export const updateVendor = async (eventID, vendorID, args) => {
  let responseVendor = null;

  try {
    responseVendor = await axios({
      method: "post",
      url: TicketingApiUri + "updatevendor.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        eventID: eventID,
        vendorID: vendorID,
        name: args?.name,
        description: args?.description,
        img: args?.img,
        category: args?.category,
        location: args?.location,
        orderAbility: args?.orderAbility,
        featured: args?.featured,
        maxOrders: args?.maxOrders,
        useOrder: args?.useOrder,
        cardSecurity: args?.cardSecurity,
        data: args?.data,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseVendor = error.response;
  } finally {
    if (responseVendor.data.status !== "200") {
      return null;
    }
    return responseVendor.data;
  }
};

/**
 * getVendorTransactions - gets the transactions for the vendor with the given vendorID
 * @param {*} vendorID - the vendor ID of the vendor to get the transactions for
 * @param {*} page - the page of transactions to get
 * @returns - the transactions for the vendor
 */
export const getVendorTransactions = async (vendorID, page) => {
  let responseTransaction;

  try {
    responseTransaction = await axios.get(
      TicketingApiUri +
        "readtransaction.php?apikey=" +
        apiKey +
        "&vendorID=" +
        vendorID +
        "&sort=DESC&page=" +
        page +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken
    );
  } catch (error) {
    responseTransaction = error.response;
  } finally {
    if (responseTransaction.data.status !== "200") {
      return null;
    }

    return responseTransaction.data.transactions;
  }
};

/**
 * getVendorSections - gets the sections for the vendor with the given vendorID
 * @param {*} vendorID - the vendor ID of the vendor to get the sections for
 * @returns - the sections for the vendor
 */
export const getVendorSections = async (vendorID) => {
  let responseSection;

  try {
    responseSection = await axios.get(
      TicketingApiUri +
        "readsection.php?apikey=" +
        apiKey +
        "&vendorID=" +
        vendorID +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken
    );
  } catch (error) {
    responseSection = error.response;
  } finally {
    if (responseSection.data.status !== "200") {
      return null;
    }
    return responseSection.data.sections;
  }
};

/**
 * createSection - creates a section for the vendor with the given vendorID
 * @param {*} vendorID - the vendor ID of the vendor to create the section for
 * @param {*} args - arguments for the section
 * @returns - the section ID of the created section
 */
export const createSection = async (vendorID, args) => {
  let responseSection;

  try {
    responseSection = await axios({
      method: "post",
      url: TicketingApiUri + "createsection.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        vendorID: vendorID,
        name: args?.name,
        description: args?.description,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseSection = error.response;
  } finally {
    if (responseSection.data.status !== "201") {
      return null;
    }
    return responseSection.data.sectionID;
  }
};

/**
 * updateSection - updates the section with the given sectionID
 * @param {*} vendorID - the vendor ID of the vendor to update the section from
 * @param {*} sectionID - the section ID of the section to update
 * @param {*} args - arguments for the section
 * @returns - the section data
 */
export const updateSection = async (vendorID, sectionID, args) => {
  let responseSection;

  try {
    responseSection = await axios({
      method: "post",
      url: TicketingApiUri + "updatesection.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        vendorID: vendorID,
        sectionID: sectionID,
        name: args?.name,
        description: args?.description,
        lim: args?.lim,
        data: args?.data,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseSection = error.response;
  } finally {
    if (responseSection.data.status !== "200") {
      return null;
    }
    return responseSection.data;
  }
};

/**
 * deleteSection - deletes the section with the given sectionID
 * @param {*} vendorID - the vendor ID of the vendor to delete the section from
 * @param {*} sectionID - the section ID of the section to delete
 * @returns - the section data
 */
export const deleteSection = async (vendorID, sectionID) => {
  let responseSection;

  try {
    responseSection = await axios({
      method: "post",
      url: TicketingApiUri + "deletesection.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        sectionID: sectionID,
        vendorID: vendorID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseSection = error.response;
  } finally {
    if (responseSection.data.status !== "200") {
      return null;
    }

    return responseSection.data;
  }
};

/**
 * removeSection - removes the section with the given sectionID and all items associated with it
 * @param {*} sectionID - the section ID of the section to remove
 * @returns - the deleted section data
 */
export const removeSection = async (vendorID, sectionID) => {
  let responseItems = await getVendorItems(vendorID);

  // if getVendoirItems fails, return null
  if (responseItems === null) {
    console.error(`getVendorItems() on section ${vendorID} failed.`);
    return null;
  }

  // filter items to only include items in the section
  let itemsInSection = responseItems.items.filter(
    (item) => item.sectionID === sectionID
  );

  // delete all items in the section
  for (let i = 0; i < itemsInSection.length; i++) {
    let responseItem = await deleteItem(vendorID, itemsInSection[i].itemID);

    // if deleteItem fails, return null
    if (responseItem === null) {
      console.error(`deleteItem() on item ${itemsInSection[i].itemID} failed.`);
      continue;
    }
  }

  // delete the section
  let responseSection = await deleteSection(vendorID, sectionID);

  // if deleteSection fails, return null
  if (responseSection === null) {
    console.error(`deleteSection() on section ${sectionID} failed.`);
    return null;
  } else {
    return responseSection;
  }
};

/**
 * getVendorItems - gets the items for the vendor with the given vendorID
 * @param {*} vendorID - the vendor ID of the vendor to get the items for
 * @returns - the items for the vendor
 */
export const getVendorItems = async (vendorID) => {
  let responseItem;

  try {
    responseItem = await axios.get(
      TicketingApiUri +
        "readitem.php?apikey=" +
        apiKey +
        "&vendorID=" +
        vendorID +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken
    );
  } catch (error) {
    responseItem = error.response;
  } finally {
    if (responseItem.data.status !== "200") {
      return null;
    }

    return responseItem?.data;
  }
};

/**
 * createItem - creates an item for the vendor with the given vendorID
 * @param {*} vendorID - the vendor ID of the vendor to create the item for
 * @param {*} args - arguments for the item
 * @returns - the item ID of the created item
 */
export const createItem = async (
  vendorID,
  args = { name: "Untitled Item" }
) => {
  let responseItem;

  try {
    responseItem = await axios({
      method: "post",
      url: TicketingApiUri + "createitem.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        vendorID: vendorID,
        sectionID: args?.sectionID,
        name: args?.name,
        description: args?.description,
        price: args?.price,
        priceType: args?.priceType,
        quantity: args?.quantity,
        limitPerOrder: args?.limitPerOrder,
        visible: args?.visible,
        data: args?.data,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseItem = error.response;
  } finally {
    if (responseItem.data.status !== "201") {
      return null;
    }

    return responseItem.data.itemID;
  }
};

/**
 * updateItem - updates the item with the given itemID
 * @param {*} vendorID - the vendor ID of the vendor to update the item for
 * @param {*} itemID - the item ID of the item to update
 * @param {*} args - arguments for the item
 * @returns - the item data
 */
export const updateItem = async (vendorID, itemID, args) => {
  let responseItem;

  try {
    responseItem = await axios({
      method: "post",
      url: TicketingApiUri + "updateitem.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        vendorID: vendorID,
        itemID: itemID,
        name: args?.name,
        description: args?.description,
        img: args?.img,
        price: args?.price,
        priceType: args?.priceType,
        limitPerOrder: args?.limitPerOrder,
        visible: args?.visible,
        quantity: args?.quantity,
        sectionID: args?.sectionID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseItem = error.response;
  } finally {
    if (responseItem.data.status !== "200") {
      return null;
    }

    return responseItem.data;
  }
};

/**
 * deleteItem - deletes the item with the given itemID
 * @param {*} vendorID - the vendor ID of the vendor to delete the item from
 * @param {*} itemID - the item ID of the item to delete
 * @returns - the item data
 */
export const deleteItem = async (vendorID, itemID) => {
  let responseItem;

  try {
    responseItem = await axios({
      method: "post",
      url: TicketingApiUri + "deleteitem.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        vendorID: vendorID,
        itemID: itemID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseItem = error.response;
  } finally {
    if (responseItem.data.status !== "200") {
      // handle error
      return null;
    }
    return responseItem.data;
  }
};

/**
 * addOperator - adds an operator to the vendor with the given vendorID
 * @param {*} vendorID - the vendor ID of the vendor to add the operator to
 * @param {*} email - the EndevreID email of the operator to add
 * @returns - the operator data
 */
export const addOperator = async (vendorID, email) => {
  let responseCreateOperator;
  try {
    responseCreateOperator = await axios({
      method: "post",
      url: TicketingApiUri + "createoperator.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        vendorID: vendorID,
        endevreLogin: email,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  } catch (error) {
    responseCreateOperator = error.response;
  } finally {
    if (responseCreateOperator.data.status !== "201") {
      return null;
    }

    return responseCreateOperator.data;
  }
};

export const getVendorOrders = async (vendorID) => {
  let responseOrder;

  try {
    responseOrder = await axios.get(
      TicketingApiUri +
        "readorder.php?apikey=" +
        apiKey +
        "&vendorID=" +
        vendorID +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken
    );
  } catch (error) {
    responseOrder = error.response;
  } finally {
    if (responseOrder.data.status !== "200") {
      return null;
    }

    return responseOrder.data.orders;
  }
};

export const createOrganization = async (args) => {
  let responseOrganization;

  try {
    responseOrganization = await axios({
      method: "post",
      url: TicketingApiUri + "createorganization.php",
      data: {
        apikey: apiKey,
        token: userNormalToken,
        deviceID: deviceID,
        name: args?.name || "",
        description: args?.description || "",
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseOrganization = error.response;
  } finally {
    if (responseOrganization.data.status !== "201") {
      return null;
    }

    return responseOrganization.data;
  }
};

export const getOrgInterestForm = async (orgID, args) => {
  let responseInterestForm;

  try {
    responseInterestForm = await axios.get(
      TicketingApiUri +
        "organizations/getorganizationif.php?apikey=" +
        apiKey +
        "&organizationID=" +
        orgID
    );
  } catch (error) {
    responseInterestForm = error.response;
  } finally {
    console.log("RESPONSE INTEREST FORM");
    console.log(responseInterestForm.data);

    if (responseInterestForm.data.status !== "200") {
      console.error(
        "Error getting interest form: " +
          responseInterestForm?.data?.error_message
      );
      return null;
    }

    return responseInterestForm.data;
  }
};

export const saveInterestForm = async (orgID, interestForm, args) => {
  // first check if the interest form is stringified
  if (typeof interestForm !== "string") {
    interestForm = JSON.stringify(interestForm);
  }

  let responseInterestForm;

  try {
    responseInterestForm = await axios({
      method: "post",
      url: TicketingApiUri + "updateorganization.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        organizationID: orgID,
        ifCustomFields: interestForm,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseInterestForm = error.response;
  } finally {
    if (responseInterestForm.data.status !== "200") {
      return null;
    }
    console.log("RESPONSE INTEREST FORM SAVE");
    console.log(responseInterestForm.data);

    return responseInterestForm.data;
  }
};

/**
 * creates an interest form submission
 * @param {String} orgID
 * @param {String} firstName
 * @param {String} lastName
 * @param {String} email
 * @param {Boolean} newsletter
 * @param {String} customFields
 * @param {*} args
 * @returns
 */
export const createInterestFormSubmission = async (
  orgID,
  firstName,
  lastName,
  email,
  newsletter,
  customFields,
  args
) => {
  // first check if the interest form is stringified
  if (typeof customFields !== "string") {
    customFields = JSON.stringify(customFields);
  }

  let responseInterestForm;

  try {
    responseInterestForm = await axios({
      method: "post",
      url: TicketingApiUri + "createifsubmission.php",
      data: {
        apikey: apiKey,
        organizationID: orgID,
        firstName: firstName,
        lastName: lastName,
        email: email,
        graduationYear: "none",
        newsletter: newsletter ? "1" : "0",
        customFields: customFields,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseInterestForm = error.response;
  } finally {
    if (responseInterestForm.data.status !== "201") {
      return null;
    }
    console.log("RESPONSE INTEREST FORM SUBMISSION");
    console.log(responseInterestForm.data);

    return responseInterestForm.data;
  }
};

export const readInterestFormSubmission = async (orgID) => {
  let responseInterestForm;

  try {
    responseInterestForm = await axios.get(
      TicketingApiUri +
        "readifsubmission.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&organizationID=" +
        orgID
    );
  } catch (error) {
    responseInterestForm = error.response;
  } finally {
    if (responseInterestForm.data.status !== "200") {
      return null;
    }

    console.log("RESPONSE INTEREST FORM SUBMISSION");
    console.log(responseInterestForm.data);

    return responseInterestForm.data;
  }
};

export const getRoles = async (mode, id, args = []) => {
  let responseRoles;

  const modes = {
    event: "eventID",
    organization: "organizationID",
  };

  try {
    responseRoles = await axios.get(
      TicketingApiUri +
        "roles/readroles.php" +
        "?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&" +
        modes[mode] +
        "=" +
        id +
        "&" +
        args.join("&")
    );
  } catch (error) {
    responseRoles = error.response;
  } finally {
    if (responseRoles.data.status !== "200") {
      return null;
    }

    return responseRoles.data;
  }
};

export const createRole = async (mode, id = "", args = {}) => {
  let responseRoles;

  const modes = {
    event: "eventID",
    organization: "organizationID",
  };

  try {
    responseRoles = await axios({
      method: "post",
      url: TicketingApiUri + "roles/createrole.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        [modes[mode]]: id,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseRoles = error.response;
  } finally {
    return responseRoles.data;
  }
};

export const removeRole = async (mode, id = "", args = {}) => {};

export const updateRole = async (roleID, args = {}) => {
  let responseRoles;

  try {
    responseRoles = await axios({
      method: "post",
      url: TicketingApiUri + "roles/updaterole.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        roleID: roleID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseRoles = error.response;
  } finally {
    return responseRoles.data;
  }
};

export const deleteRole = async (roleID) => {
  let responseRoles;

  try {
    responseRoles = await axios({
      method: "post",
      url: TicketingApiUri + "roles/deleterole.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        roleID: roleID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseRoles = error.response;
  } finally {
    return responseRoles.data;
  }
};

export const addRoleToUsers = async (roleID, userIDs = []) => {
  let responseRoles;

  try {
    responseRoles = await axios({
      method: "post",
      url: TicketingApiUri + "roles/addroletousers.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        roleID: roleID,
        "userIDs[]": userIDs,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseRoles = error.response;
  } finally {
    return responseRoles.data;
  }
};

export const removeRoleFromUsers = async (roleID, userIDs = []) => {
  let responseRoles;

  try {
    responseRoles = await axios({
      method: "post",
      url: TicketingApiUri + "roles/removerolefromusers.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        roleID: roleID,
        "userIDs[]": userIDs,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseRoles = error.response;
  } finally {
    return responseRoles.data;
  }
};

export const updateOrgBannerImg = async (orgID, bannerImg, args) => {
  let responseOrganization;

  try {
    responseOrganization = await axios({
      method: "post",
      url: TicketingApiUri + "updateorganization.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        organizationID: orgID,
        banner: bannerImg,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseOrganization = error.response;
  } finally {
    if (responseOrganization.data.status !== "200") {
      return null;
    }

    return responseOrganization.data;
  }
};

export const getOrgPage = async (orgID, args) => {
  let responseOrganization;

  try {
    responseOrganization = await axios.get(
      TicketingApiUri +
        "organizations/getorganizationpage.php?apikey=" +
        apiKey +
        "&organizationID=" +
        orgID
    );
  } catch (error) {
    responseOrganization = error.response;
  } finally {
    console.log("RESPONSE ORG PAGE");
    console.log(responseOrganization.data);

    if (responseOrganization.data.status !== "200") {
      console.error(
        "Error getting org page: " + responseOrganization?.data?.error_message
      );
      return null;
    }

    return responseOrganization.data;
  }
};

export const updateOrgData = async (orgID, orgArgs, args) => {
  let responseOrganization;

  try {
    responseOrganization = await axios({
      method: "post",
      url: TicketingApiUri + "updateorganization.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        organizationID: orgID,
        ...orgArgs,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseOrganization = error.response;
  } finally {
    if (responseOrganization.data.status !== "200") {
      return responseOrganization.data;
    }
    console.log("RESPONSE ORG PAGE SAVE");
    console.log(responseOrganization.data);

    return responseOrganization.data;
  }
};

export const updateEvent = async (eventID, eventArgs, args) => {
  let responseEvent;

  try {
    responseEvent = await axios({
      method: "post",
      url: TicketingApiUri + "updateevent.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        ...eventArgs,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseEvent = error.response;
  } finally {
    // if (responseEvent.data.status !== "200") {
    //   return null;
    // }
    console.log("RESPONSE EVENT SAVE");
    console.log(responseEvent.data);

    return responseEvent.data;
  }
};

export const updateEventTicket = async (
  eventID,
  ticketID,
  ticketArgs,
  args
) => {
  let responseTicket;

  try {
    responseTicket = await axios({
      method: "post",
      url: TicketingApiUri + "updateform.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        formID: ticketID,
        ...ticketArgs,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseTicket = error.response;
  } finally {
    if (responseTicket.data.status !== "200") {
      return responseTicket.data;
    }
    console.log("RESPONSE TICKET SAVE");
    console.log(responseTicket.data);

    return responseTicket.data;
  }
};

export const getTimeNow = (timezone = "") => {
  let dt = new DateTime();

  // get list of timezones
  let timezones = Intl.supportedValuesOf("timeZone");

  // check if the timezone is valid
  if (timezones.includes(timezone)) {
    dt.setZone(timezone);
  }

  return dt.toUnixInteger();
};

export const unixToTimeString = (
  time,
  timezone = "",
  format = "LLLL dd, yyyy, hh:mm a"
) => {
  // get list of timezones
  let dt, timeInt;
  let timezones = Intl.supportedValuesOf("timeZone");

  try {
    timeInt = parseInt(time);
  } catch (error) {
    console.error("Error parsing time: " + error);
    return null;
  }

  // check if the timezone is valid
  if (timezones.includes(timezone)) {
    dt = DateTime.fromSeconds(timeInt, { zone: timezone });
  } else {
    dt = DateTime.fromSeconds(timeInt, { zone: "local" });
  }

  return dt.toFormat(format);
};

export const dateStringToUnix = (dateString, timezone = "") => {
  let dt;

  // get list of timezones
  let timezones = Intl.supportedValuesOf("timeZone");

  // check if the timezone is valid
  if (timezones.includes(timezone)) {
    dt = DateTime.fromFormat(dateString, "yyyy-MM-dd HH:mm", {
      zone: timezone,
    });
  } else {
    dt = DateTime.fromFormat(dateString, "yyyy-MM-dd HH:mm", { zone: "local" });
  }

  return dt.toSeconds();
};

export const getOrgIDByCustomURL = async (customURL) => {
  let responseOrganization;

  try {
    responseOrganization = await axios.get(
      TicketingApiUri +
        "organizations/getorganizationidbycustomurl.php?apikey=" +
        apiKey +
        "&customUrl=" +
        customURL
    );
  } catch (error) {
    responseOrganization = error.response;
  } finally {
    console.log("RESPONSE ORG ID");
    console.log(responseOrganization.data);

    if (responseOrganization.data.status !== "200") {
      console.error(
        "Error getting org id: " + responseOrganization?.data?.error_message
      );
      return responseOrganization.data;
    }

    return responseOrganization.data;
  }
};

export const getOrgDataByIDorCustomURL = async (id) => {
  let orgID = id;

  // first check if the orgID is a customURL
  let orgIDResponse = await getOrgIDByCustomURL(id);

  // if the orgID is a customURL, set the orgID to the returned orgID
  if (orgIDResponse?.status === "200") {
    orgID = orgIDResponse?.organizationId;
  }

  // fetch the org data
  let orgResponse = await getOrgData(orgID);

  return orgResponse;
};

/**
 * This function gets the stripe status for the organization with the given orgID
 * @param {String} orgID - the organization ID of the organization to get the stripe status for
 * @param {*} args
 * @returns
 */
export const getStripeStatus = async (orgID, args) => {
  let responseStripe = null;

  try {
    responseStripe = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "organizations/getstripestatus.php?apikey=" +
        apiKey +
        "&organizationID=" +
        orgID,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "device-ID": deviceID,
        token: userNormalToken,
      },
    });
  } catch (error) {
    responseStripe = error.response;
  } finally {
    if (responseStripe?.data?.status !== "200") {
      // handle error
      console.error(
        "Error fetching stripe status: ",
        responseStripe?.data?.error_message
      );
    }

    return responseStripe?.data;
  }
};

export const startStripeSetup = async (orgID, args) => {
  let responseStripe = null;

  try {
    responseStripe = await axios({
      method: "post",
      url: TicketingApiUri + "organizations/startstripesetup.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        organizationID: orgID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseStripe = error.response;
  } finally {
    if (responseStripe?.data?.status !== "200") {
      // handle error
      console.error(
        "Error starting stripe setup: ",
        responseStripe?.data?.error_message
      );
    }

    return responseStripe?.data;
  }
};

export const createCart = async (args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "orders/createorderusd.php",
      data: {
        apikey: apiKey,
        // deviceID: deviceID,
        // token: userNormalToken,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "201") {
      // handle error
      console.error("Error creating cart: ", responseCart?.data?.error_message);
    }
    console.log("RESPONSE CART", responseCart?.data);

    return responseCart?.data;
  }
};

export const readCart = async (cartID) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "orders/readorder.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&orderID=" +
        cartID,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error("Error reading cart: ", responseCart?.data?.error_message);
    }
    console.log("RESPONSE CART", responseCart?.data);

    return responseCart?.data;
  }
};

export const readCartSuccess = async (cartID, email) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "orders/readorderdetailsbyemailandorderid.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&orderID=" +
        cartID +
        "&email=" +
        encodeURIComponent(email),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error("Error reading cart: ", responseCart?.data?.error_message);
    }
    console.log("RESPONSE CART", responseCart?.data);

    return responseCart?.data;
  }
};

export const updateCart = async (cartID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "orders/updateorder.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error("Error updating cart: ", responseCart?.data?.error_message);
    }
    console.log("RESPONSE CART", responseCart?.data);

    return responseCart?.data;
  }
};

export const removeItemFromCart = async (cartID, eventID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "orders/removeitemfromorderusd.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        eventID: eventID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error(
        "Error removing item from cart: ",
        responseCart?.data?.error_message
      );
    }
    console.log("RESPONSE REMOVE ITEM FROM CART", responseCart?.data);

    return responseCart?.data;
  }
};

export const addItemToCart = async (cartID, eventID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "orders/additemtoorderusd.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        eventID: eventID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error(
        "Error adding item to cart: ",
        responseCart?.data?.error_message
      );
    }
    console.log("RESPONSE ADD ITEM TO CART", responseCart?.data);

    return responseCart?.data;
  }
};

export const createTicketSubmission = async (cartID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "submissions/createsubmission.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "201") {
      // handle error
      console.error(
        "Error creating ticket submission: ",
        responseCart?.data?.error_message
      );
    }
    console.log("RESPONSE CREATE TICKET SUBMISSION", responseCart?.data);

    return responseCart?.data;
  }
};

export const updateTicketSubmission = async (cartID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "submissions/updatesubmission.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error(
        "Error updating ticket submission: ",
        responseCart?.data?.error_message
      );
    }
    console.log("RESPONSE UPDATE TICKET SUBMISSION", responseCart?.data);

    return responseCart?.data;
  }
};

export const createNSubmissions = async (cartID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "submissions/creatensubmissions.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "201") {
      // handle error
      console.error(
        "Error creating ticket submission: ",
        responseCart?.data?.error_message
      );
    }
    console.log("RESPONSE CREATE TICKET SUBMISSION", responseCart?.data);

    return responseCart?.data;
  }
};

export const getShopVendors = async (eventID, args) => {
  let responseShop = null;

  try {
    responseShop = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "vendors/readvendorsbyeventid.php?vendorType=1&apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&eventID=" +
        eventID,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseShop = error.response;
  } finally {
    if (responseShop?.data?.status !== "200") {
      // handle error
      console.error(
        "Error getting shop vendors: ",
        responseShop?.data?.error_message
      );
    }
    console.log("RESPONSE SHOP VENDORS", responseShop?.data);

    return responseShop?.data;
  }
};

export const getShopItems = async (vendorID, args) => {
  let responseShop = null;

  try {
    responseShop = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "vendors/readvendorbyvendorid.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&vendorID=" +
        vendorID,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    responseShop = error.response;
  } finally {
    if (responseShop?.data?.status !== "200") {
      // handle error
      console.error(
        "Error getting shop items: ",
        responseShop?.data?.error_message
      );
    }
    console.log("RESPONSE SHOP ITEMS", responseShop?.data);

    return responseShop?.data;
  }
};

export const createShopItem = async (
  vendorID,
  name,
  description,
  price,
  args
) => {
  let responseShop = null;

  try {
    responseShop = await axios({
      method: "post",
      url: TicketingApiUri + "createitem.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        vendorID: vendorID,
        name: name,
        description: description,
        price: price,
        priceType: "usd",
        sectionID: "none",
        quantity: "-1",
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    console.error(error);
    responseShop = error.response;
  } finally {
    if (responseShop?.data?.status !== "201") {
      // handle error
      console.error(
        "Error creating shop item: ",
        responseShop?.data?.error_message
      );
    }
    console.log("RESPONSE CREATE SHOP ITEM", responseShop?.data);

    return responseShop?.data;
  }
};

export const updateShopItem = async (itemID, args) => {
  let responseShop = null;

  try {
    responseShop = await axios({
      method: "post",
      url: TicketingApiUri + "updateitem.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        itemID: itemID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    console.error(error);
    responseShop = error.response;
  } finally {
    if (responseShop?.data?.status !== "200") {
      // handle error
      console.error(
        "Error updating shop item: ",
        responseShop?.data?.error_message
      );
    }
    console.log("RESPONSE UPDATE SHOP ITEM", responseShop?.data);

    return responseShop?.data;
  }
};

export const setItemOrder = async (itemIDsArray, sectionID, vendorID, args) => {
  let responseShop = null;

  try {
    responseShop = await axios({
      method: "post",
      url: TicketingApiUri + "items/setitemorder.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        sectionID: sectionID,
        vendorID: vendorID,
        "itemIDs[]": itemIDsArray,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    console.error(error);
    responseShop = error.response;
  } finally {
    if (responseShop?.data?.status !== "200") {
      // handle error
      console.error(
        "Error setting item order: ",
        responseShop?.data?.error_message
      );
    }
    console.log("RESPONSE SET ITEM ORDER", responseShop?.data);

    return responseShop?.data;
  }
};

export const createEventStore = async (eventID, args) => {
  let responseShop = null;

  try {
    responseShop = await axios({
      method: "post",
      url: TicketingApiUri + "events/createeventstore.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        vendorType: "1",
        name: "New Event Shop",
        description:
          "These are additional items for the event. All items are tied to your ticket",
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    console.error(error);
    responseShop = error.response;
  } finally {
    if (responseShop?.data?.status !== "201") {
      // handle error
      console.error(
        "Error creating event store: ",
        responseShop?.data?.error_message
      );
    }
    console.log("RESPONSE CREATE EVENT STORE", responseShop?.data);

    return responseShop?.data;
  }
};

export const updateEventStore = async (eventID, vendorID, args) => {
  let responseShop = null;

  try {
    responseShop = await axios({
      method: "post",
      url: TicketingApiUri + "events/updateeventstore.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        storeID: vendorID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    console.error(error);
    responseShop = error.response;
  } finally {
    if (responseShop?.data?.status !== "200") {
      // handle error
      console.error(
        "Error updating event store: ",
        responseShop?.data?.error_message
      );
    }
    console.log("RESPONSE UPDATE EVENT STORE", responseShop?.data);

    return responseShop?.data;
  }
};

/**
 * Calculates the iget and upay prices
 * @param {Number} price - price to be converted
 * @param {*} itemType - type of item ("T" for ticket, "I" for item)
 * @param {*} eventID - event ID of the item
 * @param {*} type - type of conversion ("iget" or "upay")
 * @param {*} args
 * @returns
 */
export const calculatePrice = async (price, itemType, eventID, type, args) => {
  let responsePrice = null;

  try {
    responsePrice = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "items/pricecalculator.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&itemType=" +
        itemType +
        `&${type}=${price}` +
        "&eventID=" +
        eventID,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
  } catch (error) {
    console.error(error);
    responsePrice = error.response;
  } finally {
    if (responsePrice?.data?.status !== "200") {
      // handle error
      console.error(
        "Error calculating price: ",
        responsePrice?.data?.error_message
      );
    }
    console.log("RESPONSE CALCULATE PRICE", responsePrice?.data);

    return responsePrice?.data;
  }
};

export const checkoutRegOrder = async (cartID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "orders/checkoutregorderusd.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE CHECKOUT REG ORDER", responseCart?.data);
  } catch (error) {
    console.error(error);
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error(
        "Error checking out reg order: ",
        responseCart?.data?.error_message
      );
    }

    return responseCart?.data;
  }
};

export const deleteCartOnExpire = async (cartID, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "orders/deleteorderusd.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE DELETE CART ON EXPIRE", responseCart?.data);
  } catch (error) {
    console.error(error);
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error(
        "Error deleting cart on expire: ",
        responseCart?.data?.error_message
      );
    }

    return responseCart?.data;
  }
};

export const checkoutCart = async (cartID, paymentType, email, args) => {
  let responseCart = null;

  try {
    responseCart = await axios({
      method: "post",
      url: TicketingApiUri + "orders/checkoutorderusd.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        orderID: cartID,
        paymentType: paymentType,
        email: email,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE CHECKOUT CART", responseCart?.data);
  } catch (error) {
    console.error(error);
    responseCart = error.response;
  } finally {
    if (responseCart?.data?.status !== "200") {
      // handle error
      console.error(
        "Error checking out cart: ",
        responseCart?.data?.error_message
      );
    }

    return responseCart?.data;
  }
};

export const formatToUSD = (price, minNumDigits = 2, maxNumDigits = 2) => {
  return Number(price).toLocaleString("en-US", {
    minimumFractionDigits: minNumDigits,
    maximumFractionDigits: maxNumDigits,
  });
};

export const fulfillOrderItem = async (itemID, args) => {
  let responseOrder = null;

  try {
    responseOrder = await axios({
      method: "post",
      url: TicketingApiUri + "orders/fulfilliteminorder.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        itemID: itemID,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE FULFILL ORDER ITEM", responseOrder?.data);
  } catch (error) {
    console.error(error);
    responseOrder = error.response;
  } finally {
    if (responseOrder?.data?.status !== "200") {
      // handle error
      console.error(
        "Error fulfilling order item: ",
        responseOrder?.data?.error_message
      );
    }

    return responseOrder?.data;
  }
};

export const requestPayout = async (eventID, args) => {
  let responseOrder = null;

  try {
    responseOrder = await axios({
      method: "post",
      url: TicketingApiUri + "events/requestpayout.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE REQUEST PAYOUT", responseOrder?.data);
  } catch (error) {
    console.error(error);
    responseOrder = error.response;
  } finally {
    if (responseOrder?.data?.status !== "200") {
      // handle error
      console.error(
        "Error requesting payout: ",
        responseOrder?.data?.error_message
      );
    }

    return responseOrder?.data;
  }
};

export const getEventSeatMapAdmin = async (eventID, args) => {
  let responseSeatMap = null;

  try {
    responseSeatMap = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "seats/readsectionadmin.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&eventID=" +
        eventID +
        "&section=1",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE GET EVENT SEAT MAP", responseSeatMap?.data);
  } catch (error) {
    console.error(error);
    responseSeatMap = error.response;
  } finally {
    if (responseSeatMap?.data?.status !== "200") {
      // handle error
      console.error(
        "Error getting event seat map: ",
        responseSeatMap?.data?.error_message
      );
    }

    return responseSeatMap?.data;
  }
};

export const getEventSeatMapPublic = async (eventID, args) => {
  let responseSeatMap = null;

  try {
    responseSeatMap = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "seats/readsection.php?apikey=" +
        apiKey +
        "&eventID=" +
        eventID +
        "&section=1",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE GET EVENT SEAT MAP", responseSeatMap?.data);
  } catch (error) {
    console.error(error);
    responseSeatMap = error.response;
  } finally {
    if (responseSeatMap?.data?.status !== "200") {
      // handle error
      console.error(
        "Error getting event seat map: ",
        responseSeatMap?.data?.error_message
      );
    }

    return responseSeatMap?.data;
  }
};

export const getSeatSectionsByEventID = async (eventID, args) => {
  let responseSeatMap = null;

  try {
    responseSeatMap = await axios({
      method: "get",
      url:
        TicketingApiUri +
        "seats/readsectionsbyeventid.php?apikey=" +
        apiKey +
        "&deviceID=" +
        deviceID +
        "&token=" +
        userNormalToken +
        "&eventID=" +
        eventID,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log(
      "RESPONSE GET SEAT SECTIONS BY EVENT ID",
      responseSeatMap?.data
    );
  } catch (error) {
    console.error(error);
    responseSeatMap = error.response;
  } finally {
    if (responseSeatMap?.data?.status !== "200") {
      // handle error
      console.error(
        "Error getting seat sections by event ID: ",
        responseSeatMap?.data?.error_message
      );
    }

    return responseSeatMap?.data;
  }
};

export const setSeatStatus = async (
  eventID,
  section,
  row,
  col,
  status,
  submissionID,
  args
) => {
  let responseSeatMap = null;

  try {
    responseSeatMap = await axios({
      method: "post",
      url: TicketingApiUri + "seats/setseatstatus.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        section: section,
        seats: JSON.stringify([
          { row: row, col: col, status: status, submissionID: submissionID },
        ]),
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE SET SEAT STATUS", responseSeatMap?.data);
  } catch (error) {
    console.error(error);
    responseSeatMap = error.response;
  } finally {
    if (responseSeatMap?.data?.status !== "200") {
      // handle error
      console.error(
        "Error setting seat status: ",
        responseSeatMap?.data?.error_message
      );
    }

    return responseSeatMap?.data;
  }
};

export const setSeatMap = async (eventID, section, numRows, numCols, args) => {
  let responseSeatMap = null;

  try {
    responseSeatMap = await axios({
      method: "post",
      url: TicketingApiUri + "seats/setseats.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        section: section,
        numRow: numRows,
        numCol: numCols,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE SET SEATS", responseSeatMap?.data);
  } catch (error) {
    console.error(error);
    responseSeatMap = error.response;
  } finally {
    if (responseSeatMap?.data?.status !== "200") {
      // handle error
      console.error(
        "Error setting seats: ",
        responseSeatMap?.data?.error_message
      );
    }

    return responseSeatMap?.data;
  }
};

export const deleteSeatMap = async (eventID, section, args) => {
  let responseSeatMap = null;

  try {
    responseSeatMap = await axios({
      method: "post",
      url: TicketingApiUri + "seats/deletesection.php",
      data: {
        apikey: apiKey,
        deviceID: deviceID,
        token: userNormalToken,
        eventID: eventID,
        section: section,
        ...args,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE DELETE SEATS", responseSeatMap?.data);
  } catch (error) {
    console.error(error);
    responseSeatMap = error.response;
  } finally {
    if (responseSeatMap?.data?.status !== "200") {
      // handle error
      console.error(
        "Error deleting seats: ",
        responseSeatMap?.data?.error_message
      );
    }

    return responseSeatMap?.data;
  }
};

/**
 * Adds a seat from seat map to a given submission
 * Can be used on both admin side and public side
 * @param {String} type - "admin" or "public"
 * @param {String} submissionID
 * @param {Int} section
 * @param {Int} row
 * @param {Int} col
 * @param {*} args
 * @returns
 */
export const addSeatToSubmission = async (
  type,
  submissionID,
  section,
  row,
  col,
  args
) => {
  let responseSeatMap = null;

  try {
    let data = {
      apikey: apiKey,
      submissionID: submissionID,
      section: section,
      row: row,
      col: col,
      ...args,
    };

    if (type === "admin") {
      data.deviceID = deviceID;
      data.token = userNormalToken;
    }

    responseSeatMap = await axios({
      method: "post",
      url: TicketingApiUri + "seats/addseattosubmission.php",
      data: data,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });

    console.log("RESPONSE ADD SEAT TO SUBMISSION", responseSeatMap?.data);
  } catch (error) {
    console.error(error);
    responseSeatMap = error.response;
  } finally {
    if (responseSeatMap?.data?.status !== "200") {
      // handle error
      console.error(
        "Error adding seat to submission: ",
        responseSeatMap?.data?.error_message
      );
    }

    return responseSeatMap?.data;
  }
};

export function getUrlParam(paramName, url) {
  const targetUrl = url || window.location.href;
  const { searchParams } = new URL(targetUrl);
  const value = searchParams.get(paramName);
  return value === null ? undefined : value;
}
